export enum Seniority {
  CLevel      = 1,
  Executive   = 2,
  Director    = 3,
  Manager     = 4,
  NonManager  = 5,
  Other       = 6,
}
